import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {requireImage} from '../../utils/utils';
import {IConnectivityStandaloneStore} from './connectivity-standalone.stores';
import {IAppRootStore} from '../../app.root.store';
import {resolveLogoUrl} from '../../utils/logo-url.utils';
import './connectivity-standalone.style.scss';

interface ConnectivityStandaloneViewProps {
    connectivityStandaloneStore: IConnectivityStandaloneStore;
    rootStore: IAppRootStore;
}

@observer
export class ConnectivityStandaloneViewComponent extends TechseeBaseComponent<ConnectivityStandaloneViewProps> {
    private isSupported(): boolean {
        const {environmentService} = this.props.connectivityStandaloneStore;
        const browserVersion = Number(environmentService.browser().major) || 0;

        return (
            (environmentService.isChrome() && browserVersion >= 52) ||
            (environmentService.isFF() && browserVersion >= 52) ||
            environmentService.isIE11()
        );
    }

    private getIframeSrc(): string {
        return '/connectivity.html#standalone=yes';
    }

    renderInternal(): JSX.Element {
        const {localizationService} = this.props.connectivityStandaloneStore;
        const translate = localizationService.translate.bind(localizationService);
        const supported = this.isSupported();

        return (
            <div className={`ts-container ts-connectivity-standalone${!supported ? ' not-supported' : ''}`}>
                <header className='ts-topbar'>
                    <a href='/' className='logo'>
                        <img className='logo-img' src={resolveLogoUrl('')} alt='logo' />
                    </a>
                    <div className='ts-topbar-content'>
                        <div className='ts-breadcrumbs'>{translate('REACT.CONNECTIVITY_STANDALONE.VIEW.HEADER')}</div>
                    </div>
                </header>

                {supported && (
                    <div className='connectivity-iframe-container' style={{textAlign: 'center'}}>
                        <iframe
                            id='iframe-connectivity'
                            className='iframe-connectivity-frame'
                            src={this.getIframeSrc()}
                        />
                    </div>
                )}

                {!supported && (
                    <div className='connectivity-standalone-container' style={{textAlign: 'center'}}>
                        <h4 className='ts-connectivity-title'>
                            {translate('REACT.CONNECTIVITY_STANDALONE.VIEW.NOT_SUPPORTED_TITLE')}
                        </h4>
                        <span className='ts-connectivity-description'>
                            {translate('REACT.CONNECTIVITY_STANDALONE.VIEW.NOT_SUPPORTED_DESCRIPTION')}
                        </span>
                        <div className='ts-connectivity-browsers'>
                            <img src={requireImage('ff-icon.png')} alt='Firefox' />
                            <img src={requireImage('chrome-icon.png')} alt='Chrome' />
                            <img src={requireImage('IE11-icon.png')} alt='IE11' />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export const ConnectivityStandaloneView = inject(
    'rootStore',
    'connectivityStandaloneStore'
)(ConnectivityStandaloneViewComponent) as IReactComponent;
